"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownAuthenticationDomain = void 0;
const network_1 = require("./network");
class UnknownAuthenticationDomain {
    constructor(adapterFactory, config, internetStatusListener, organizationIdStorage, deviceTokenProvider) {
        this.domainType = "unknown";
        this.user = null;
        this.isPasswordChangeRequired = false;
        this.isLoginError = false;
        this.changeListeners = [];
        this.internetStatusManager = new network_1.InternetStatusManager(`${config.baseUrl}/api/v1/miscellaneous/ping`);
        this.internetStatusListener = internetStatusListener;
        this.internetStatusManager.startMonitoring(this.internetStatusListener);
        this.adapterFactory = adapterFactory.withAuthStatusManager(this);
        this.authAdapter = adapterFactory.createAuthAdapter();
        this.config = config;
        this.organizationIdStorage = organizationIdStorage;
        this.deviceTokenProvider = deviceTokenProvider;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("init ==> Unknown authentication init Called");
        });
    }
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("login ==> Unknown authentication state");
        });
    }
    forgotPassword() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("forgotPassword ==> Unknown authentication state");
        });
    }
    resetPassword() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("resetPassword ==> Unknown authentication state");
        });
    }
    setPassword() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("setPassword ==> Unknown authentication state");
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    checkUserAuthentication() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const isAuthenticated = yield ((_a = this.authAdapter) === null || _a === void 0 ? void 0 : _a.isAuthenticated());
            if (isAuthenticated) {
                const authenticatedDomain = yield this.createAuthenticatedDomain();
                try {
                    if (yield authenticatedDomain.init()) {
                        this.notifyChange(authenticatedDomain);
                        return true;
                    }
                }
                catch (error) {
                    if (error.code !== "FORCE_LOGOUT") {
                        throw error;
                    }
                }
            }
            return this.fallbackToUnauthenticated();
        });
    }
    fallbackToUnauthenticated() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const unauthenticatedDomain = yield this.createUnauthenticatedDomain();
            if (yield ((_a = unauthenticatedDomain.init) === null || _a === void 0 ? void 0 : _a.call(unauthenticatedDomain))) {
                this.notifyChange(unauthenticatedDomain);
            }
            return false;
        });
    }
    createAuthenticatedDomain() {
        return __awaiter(this, void 0, void 0, function* () {
            const { AuthenticatedDomain } = yield Promise.resolve().then(() => __importStar(require("./AuthenticatedDomain")));
            return new AuthenticatedDomain(this.adapterFactory, this.config, this.internetStatusManager, this.organizationIdStorage, this.deviceTokenProvider);
        });
    }
    createUnauthenticatedDomain() {
        return __awaiter(this, void 0, void 0, function* () {
            const { UnauthenticatedDomain } = yield Promise.resolve().then(() => __importStar(require("./UnauthenticatedDomain")));
            return new UnauthenticatedDomain(this.adapterFactory, this.config, this.internetStatusManager, this.organizationIdStorage, this.deviceTokenProvider);
        });
    }
    destroy() {
        throw new Error("Method not applicable");
    }
    isUserLoggedIn() {
        return false;
    }
    registerChangeListener(cb) {
        this.changeListeners.push(cb);
        return () => {
            this.changeListeners = this.changeListeners.filter(listener => listener !== cb);
        };
    }
    subscribeToCrossTabAuthChanges(callback) {
        return this.authAdapter.subscribeToCrossTabAuthChanges(callback);
    }
    logoutUser() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("logoutUser ==> Unknown authentication state");
        });
    }
    unexpectedlyLostAccess() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("unexpectedlyLostAccess ==> Unknown authentication state");
        });
    }
    updateDeviceToken() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("updateDeviceToken ==> Unknown authentication state");
        });
    }
    clearDeviceToken() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("clearDeviceToken ==> Unknown authentication state");
        });
    }
    notifyChange(replacementDomain) {
        const domainToNotify = replacementDomain || this;
        this.changeListeners.forEach(cb => cb(domainToNotify));
    }
}
exports.UnknownAuthenticationDomain = UnknownAuthenticationDomain;
